import React from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button, Dialog, DialogContent } from '@material-ui/core';
import { hideInsufficientDialog } from '../../actions/alertDialog';
import './index.css';
import variables from '../../utils/variables';
import cancelIcon from '../../assets/interactive/close.svg';
import infoIcon from '../../assets/infoIcon.svg';
import insufficientGif from '../../assets/insufficientGif.gif';

const InSufficientDialog = (props) => {
    const handleRedirect = () => {
        window.open('https://app.osmosis.zone');
    };

    return (
        <Dialog
            aria-describedby="insufficient-dialog-description"
            aria-labelledby="insufficient-dialog-title"
            className="dialog insufficient-dialog"
            open={props.open}
            onClose={props.handleClose}>
            <DialogContent className="insufficient_dialog_content">
                <img alt="cancelIcon" src={cancelIcon} onClick={props.handleClose}/>
                <div className="container">
                    <img alt="gif" src={insufficientGif}/>
                    <div className="section">
                        <div className="content">
                            <div className="header">
                                <img alt="infoIcon" src={infoIcon}/>
                                <p>{variables[props.lang].insufficient_funds}</p>
                            </div>
                            <p>{variables[props.lang].insufficient_content}</p>
                        </div>
                        <Button className="action" onClick={handleRedirect}>
                            <p>{variables[props.lang].get_flix_now}</p>
                        </Button>
                    </div>
                </div>
            </DialogContent>
        </Dialog>
    );
};

InSufficientDialog.propTypes = {
    handleClose: PropTypes.func.isRequired,
    lang: PropTypes.string.isRequired,
    open: PropTypes.bool.isRequired,
};

const stateToProps = (state) => {
    return {
        lang: state.language,
        open: state.alertDialog.insufficientDialog.open,
    };
};

const actionToProps = {
    handleClose: hideInsufficientDialog,
};

export default connect(stateToProps, actionToProps)(InSufficientDialog);
